import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemeDocsService {
  isRendered: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
}
